export default function getColorLightness(color) {
  const subpixelValuesHex = color.replace(/#/, '').match(/.{1,2}/g);
  const subpixelValuesDecimal = subpixelValuesHex.map(color =>
    parseInt(color, 16)
  );
  const lightnessR = subpixelValuesDecimal[0] * 0.299;
  const lightnessG = subpixelValuesDecimal[1] * 0.587;
  const lightnessB = subpixelValuesDecimal[2] * 0.114;
  const lightness = lightnessR + lightnessG + lightnessB;
  return lightness;
}
